import React from 'react';
import LegalLayout from '../components/LegalLayout';

export default function ContactPage() {
  return (
    <LegalLayout title="Contact Us" lastUpdated="15 May 2026">

      <p>The fastest way to reach us is email. We read everything ourselves and reply personally.</p>

      <div style={{ background: '#f8faff', border: '1.5px solid #e2e8f0', borderRadius: '14px', padding: '1.5rem', margin: '1.5rem 0' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
          <span style={{ fontSize: '1.5rem' }}>✉️</span>
          <strong style={{ fontSize: '1.05rem', color: '#0f172a' }}>Email Support</strong>
        </div>
        <p style={{ margin: '0 0 0.4rem' }}>
          <a href="mailto:support@creatorkhata.com" style={{ color: '#6366f1', fontWeight: 600 }}>support@creatorkhata.com</a>
        </p>
        <p style={{ margin: 0, color: '#64748b', fontSize: '0.9rem' }}>
          We aim to reply within 24 hours on business days (Monday – Friday, Indian Standard Time).
        </p>
      </div>

      <h2>What to include in your email</h2>
      <p>To help us respond quickly, please mention:</p>
      <ul>
        <li>The email address registered on your CreatorKhata account</li>
        <li>A clear description of your question or issue</li>
        <li>If reporting a bug — what page you were on and what you expected vs. what happened</li>
        <li>If asking about a payment — the Razorpay payment ID from your receipt email</li>
      </ul>

      <h2>Common requests</h2>
      <ul>
        <li><strong>Refund:</strong> see our <a href="/refund">Refund Policy</a> for the eligibility criteria and process.</li>
        <li><strong>Account deletion:</strong> email us from your registered address and ask to delete your account. We process within 7 business days.</li>
        <li><strong>Data export:</strong> we can export your account data (deals, invoices, content, ideas, etc.) as JSON or CSV on request. See our <a href="/privacy">Privacy Policy</a> for details on your data rights.</li>
        <li><strong>Bug reports / feature requests:</strong> always welcome. We build this app for Indian creators and your feedback shapes the roadmap.</li>
      </ul>

      <h2>Business Details</h2>
      <p>
        <strong>Tambe Technologies</strong> (operating the CreatorKhata service)<br />
        Proprietor: Raju Tambe<br />
        Bangalore, Karnataka, India<br />
        Email: <a href="mailto:support@creatorkhata.com">support@creatorkhata.com</a>
      </p>

      <h2>Other Resources</h2>
      <ul>
        <li><a href="/terms">Terms of Service</a></li>
        <li><a href="/privacy">Privacy Policy</a></li>
        <li><a href="/refund">Refund &amp; Cancellation Policy</a></li>
      </ul>

    </LegalLayout>
  );
}
